import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, Inject, NgZone, OnDestroy, OnInit, PLATFORM_ID, QueryList, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { AuthHttpService } from '@core/entity/auth/service/auth.http.service';
import { IsLoggedIn } from '@core/entity/auth/state/auth.selectors';
import { DomainService } from '@core/services/domain.service';
import { DropdownHttpService } from '@core/services/dropdown-http.service';
import { EventEmitterService } from '@core/services/event-emitter.service';
import { GameLaunchWindowTargetService } from '@core/services/game-launch-target.service.ts';
import { GameCategoryDataService } from '@core/services/games/gamecategory-data.service';
import { GameListDataService } from '@core/services/games/gamelist-data.service';
import { GeneralService } from '@core/services/general.service';
import { JackpotService } from '@core/services/jackpot.service';
import { OwlCarouselHttpService } from '@core/services/owl-carousel-http.service';
import { SeoService } from '@core/services/seo.service';
import { SystemSettingHttpService } from '@core/services/system-setting-http.service';
import { USPSectionHttpService } from '@core/services/usp-section-http.service';
import { environment } from '@env/environment';
import { select, Store } from '@ngrx/store';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ContentDataService } from '@pages/info-center/services/content-data.service';
import { GameMenuComponent } from '@pages/partial/game-menu/game-menu.component';
import { JackpotSliderComponent } from '@pages/partial/jackpot-slider/jackpot-slider.component';
import { SliderComponent } from '@pages/partial/slider/slider.component';
import { PromotionContentDataService } from '@pages/promotion/services/promotion-content-data.service';
import { LoginModalComponent } from '@shared/login-modal/login-modal.component';
import { NgMarqueeComponent } from '@shared/marquee/ng-marquee.component';
import { ReadMoreMarqueeModalComponent } from './dialogs/marquee/read-more-modal.component';
import { Pagination } from '@shared/models/pagination.model';
import { PromotionContent } from '@shared/models/promotion-content.model';
import { ClientOdometerComponent } from '@shared/odometer/client-odometer.component';
import { SafeHtmlPipe } from '@shared/pipes/safe-html.pipe';
import { svgIconList } from '@shared/svg-icon-list';
import { AppState } from '@store/reducers';
import moment from 'moment';
import { debounceTime, delay, fromEvent, map, Observable, of, Subject, Subscription, take, takeUntil, tap } from 'rxjs';
import Swal from 'sweetalert2';
import { SwiperOptions } from 'swiper/types';
import { SwiperDirective } from '@core/directive/swiper.directive';

@Component({
  selector: 'app-home',
  imports: [CommonModule, SafeHtmlPipe, TranslateModule, RouterModule, SliderComponent, NgMarqueeComponent, JackpotSliderComponent, ClientOdometerComponent, GameMenuComponent, SwiperDirective, MatExpansionModule],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  encapsulation: ViewEncapsulation.None,
})

export class HomeComponent implements OnInit, OnDestroy {
  @ViewChild('marqueeElement', { read: ElementRef }) marqueeEl?: ElementRef<HTMLElement>;
  @ViewChildren('marqueeItem', { read: ElementRef }) marqueeItems!: QueryList<ElementRef<HTMLElement>>;

  sitePrefix = environment.sitePrefix.toLocaleLowerCase();
  projectCode = environment.projectCode.toLocaleLowerCase();
  siteName = environment.siteName;
  isPlayTechClicked = false;
  memberUser$ = new Subject<any>();
  isQP20 = ['qp20', 'qp20-dark'].includes(environment.projectCode.toLowerCase());

  activeGame: any;
  casinoActive = false;
  slotsActive = false;
  sportsActive = false;
  fishingActive = false;
  esportsActive = false;
  pokerActive = false;
  activeSlotIndex = 0;

  slotsActiveGame = {
    game_provider_code: '',
    type: ''
  };
  activeSlotCategory: any;
  slotsGameDetails = {
    backGround: '',
    logo: '',
    name: '',
    details: '',
    maintenance: '',
    maintainTime: '',
    maintainEnd: '',
    image: ''
  };

  casinoActiveGame = '';
  activeCasinoCategory: any;
  casinoGameDetails = {
    backGround: '',
    logo: '',
    name: '',
    details: '',
    maintenance: '',
    maintainTime: '',
    maintainEnd: '',
    image: ''
  };

  sportsActiveGame = '';
  activeSportCategory: any;
  sportsGameDetails = {
    backGround: '',
    logo: '',
    name: '',
    details: '',
    maintenance: '',
    maintainTime: '',
    maintainEnd: '',
    image: ''
  };

  fishingActiveGame = {
    game_provider_code: '',
    type: ''
  };
  activeFishingCategory: any;
  fishingGameDetails = {
    backGround: '',
    logo: '',
    name: '',
    details: '',
    maintenance: '',
    maintainTime: '',
    maintainEnd: '',
    image: ''
  };

  esportsActiveGame = '';
  activeEsportCategory: any;
  esportsGameDetails = {
    backGround: '',
    logo: '',
    name: '',
    details: '',
    maintenance: '',
    maintainTime: '',
    maintainEnd: '',
    image: ''
  };

  pokerActiveGame = '';
  activePokerCategory: any;
  pokerGameDetails = {
    backGround: '',
    logo: '',
    name: '',
    details: '',
    maintenance: '',
    maintainTime: '',
    maintainEnd: '',
    image: ''
  };

  // For hot games display
  providers: any;
  isSkeletonHotGames: boolean = true;
  activeProviderData: any;
  slotProviders: any[] = [];
  gamelist: any;
  gameStack: any[] = [];
  hotGameCount = 0;
  firstHotGameProvider: string = null;
  path = '/assets/integrations/slots/provider-thumbnails/coming-soon-slot#.png';
  currentCountry: any;
  currentLanguage: any;
  hotGameSession: any;

  playtechLanguage = 'en';
  playtechClient: string;
  playtechGameMode = 'real';
  username: string;
  password: string;

  sportsCategories$: any[] = [];
  fishingCategories$: any[] = [];
  liveCasinoCategories$: any[] = [];
  slotsCategories$: any[] = [];
  esportCategories$: any[] = [];
  limit = 6;
  memberBalance: any;
  showPlayNow = true;
  onMaintenance: boolean;

  marquees$: any[] = [];
  maintenanceRows: any[] = [];
  marqueeContents: string[] = [];
  combinedMarquee: string[] = [];

  marqueeDuration = '40s';
  private destroy$ = new Subject<void>();

  trackByIndex = (_: number, __: unknown) => _;

  ngAfterViewInit() {
    if (!this.isBrowser) return;

    // Recalculate changed item (ex: when combinedMarquee items added)
    this.marqueeItems.changes
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.scheduleRecalc());

    // Recalculate when resize
    fromEvent(window, 'resize')
      .pipe(debounceTime(150), takeUntil(this.destroy$))
      .subscribe(() => this.scheduleRecalc());

    // Recalculate at start
    this.scheduleRecalc();
  }

  private scheduleRecalc() {
    // wait cycle to be stable (so DOM finish rendered)
    this.zone.onStable.pipe(take(1)).subscribe(() => this.recalcDuration());
  }

  private recalcDuration() {
    const el = this.marqueeEl?.nativeElement;
    if (!el) return;

    // Looking for the internal Element Content
    const content =
      el.querySelector('.marquee-content, .marquee__content, [data-marquee-content]') as HTMLElement
      || (el.firstElementChild as HTMLElement)
      || el;

    const contentWidth = content.scrollWidth;     // Content Width total
    const containerWidth = el.clientWidth;        // viewport marquee
    const distance = contentWidth + containerWidth;

    const speed = 50; // px/secs (bigger == faster)
    const duration = Math.max(distance / speed, 30); // set minimum to 30s so it's not too fast

    this.marqueeDuration = `${duration}s`;
    this.cdr.markForCheck();
  }

  currentUser: any = null;
  carouselOptions: any;
  isLoggedIn$: Observable<boolean>;
  isSkeletonCategoryLocales = true;

  dateNow: any;
  dateEnd: any;

  randomRecentImages = [
    'assets/images/madeforu/hot-games.png',
    'assets/images/madeforu/minigame-club.png',
    'assets/images/madeforu/recently-played.png',
    'assets/images/madeforu/recommended-for-you.png',
    'assets/images/madeforu/this-week-only.png',
    'assets/images/madeforu/top-win.png',
    // 'assets/images/madeforu/vip.png',
    'assets/images/madeforu/your-favourite.png'
  ];

  userStatus: any;
  vip_progress: number;
  ref_progress: number;

  smartTransfer: boolean;
  // gLive$ = []; *EURO 2020*
  today = new Date();

  language: string = null;
  contentHash: any;

  countryCode: string = null;

  tab: string;
  activeTab: any;

  gameCategoryProviders$: any;
  isGameCategoryProivdersFetched: boolean = false;
  categoryGames: any[] = [];
  activeGameCategoryCode: string;
  activeGameCategoryName: string;

  currentDateTimeUTC = moment().utc().format();
  eventEnded: any;

  categories: any;
  category_locales: any;

  faqs: any[] = [];
  faqsLength = 0;
  faqdata = 0;

  usps: any = [];
  uspNumberContents: any = [];
  uspMainContent: any;
  systemSettingOption: any;

  promotions: PromotionContent[] = [];
  isSkeletonPromotions = true;
  isSkeletonUsp = true;
  isSkeletonFaqs = true;
  params: any;
  pagination: Pagination;
  pageSize = 30;
  page = 1;

  // PROMOTION SWIPER
  promotionConfig: SwiperOptions = {
    allowTouchMove: true,
    spaceBetween: 10,
    slidesPerView: 4,
    // autoplay: {
    //   delay: 4000,
    //   disableOnInteraction: false,
    //   pauseOnMouseEnter: true
    // },
    autoplay: false,
    loop: false
  };

  hotGameConfig: SwiperOptions = {
    allowTouchMove: true,
    spaceBetween: 12,
    slidesPerView: 5,
    autoplay: false,
    loop: false
  };

  freespinDialog: string = null;
  availableProvider: any = null;
  firstAvailableProviderSL: String;

  svg: any = svgIconList;

  private subscription = new Subscription();
  private unsubscribe: Subscription[] = [];

  odometerConfig = {
    animation: 'slide',
    format: '(,ddd).dd',
    theme: 'default',
    value: 3000000.00,
    auto: true,
  }

  timer: any;
  jackpotAmount: number;

  currency: any;

  countryName: any;

  // Marquees$: any;

  // hardCodeCricketPositionProject = ['qp6', 'qp10', 'qp11', 'qp12'];

  isBrowser: boolean;

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private owlCarouselHttpService: OwlCarouselHttpService,
    public loadingBar: LoadingBarService,
    private gameCategoryDataService: GameCategoryDataService,
    private store: Store<AppState>,
    private eventEmitterService: EventEmitterService,
    private translateService: TranslateService,
    private activatedRoute: ActivatedRoute,
    private contentDataService: ContentDataService,
    private sanitizer: DomSanitizer,
    private promotionContentDataService: PromotionContentDataService,
    private uspSectionHttpService: USPSectionHttpService,
    private dropdownHttpService: DropdownHttpService,
    private systemSettingHttpService: SystemSettingHttpService,
    private jackpotService: JackpotService,
    private gameListDataService: GameListDataService,
    private seoService: SeoService,
    private gameLaunchWindowTargetService: GameLaunchWindowTargetService,
    private cdr: ChangeDetectorRef,
    private zone: NgZone,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.jackpotService.getJackpotAmount().subscribe(res => {
      this.jackpotAmount = res
    })
  }

  ngOnInit() {
    if (this.isBrowser) {
      this.currentUser = JSON.parse(localStorage.getItem('user_data'));
      this.language = localStorage.getItem('language_code')?.toUpperCase();
      this.countryCode = localStorage.getItem('country_code');
      this.freespinDialog = localStorage.getItem('freespin_dialog');
      this.availableProvider = JSON.parse(localStorage.getItem('available_providers'));
      this.providers = JSON.parse(localStorage.getItem('available_providers'));
      this.currentCountry = localStorage.getItem('country_code');
      this.currentLanguage = localStorage.getItem('language_code');
      this.hotGameSession = sessionStorage.getItem('hotGameSession') === null ? {} : JSON.parse(sessionStorage.getItem('hotGameSession'));
    }

    this.carouselOptions = this.owlCarouselHttpService.customOptions;
    this.activeTab = this.activatedRoute.snapshot.paramMap.get('tab') ? this.activatedRoute.snapshot.paramMap.get('tab') : 'casino';

    if (this.isBrowser) {
      setTimeout(() => {
        this.freespinDialog = localStorage.getItem('freespin_dialog');
        this.onTriggerDialog();

        this.eventEmitterService.triggerFreespinDialogEmitterVar = this.eventEmitterService.triggerFreespinDialogEmitter.pipe(takeUntil(this.destroy$)).subscribe(() => {
          setTimeout(() => {
            this.onTriggerDialog();
          }, 2000);
        });
      }, 2000);

      // Loop to get language code if undefined or null (also cleared in ngOnDestroy
      // so it can't keep polling after navigation if the code never resolves)
      this.languagePollInterval = setInterval(() => {
        if (this.language == undefined || this.language == null || this.language == 'null') {
          this.language = localStorage.getItem('language_code')?.toUpperCase();
        } else {
          clearInterval(this.languagePollInterval);
        }
      }, 100);
    }

    this.readAnnouncementsFromStorage();
    this.computeCombinedMarquee();

    if (this.isBrowser) {
      this.marquees$ = localStorage.getItem('marquees') !== null
        ? JSON.parse(localStorage.getItem('marquees')!)
        : [];
    }

    this.eventEmitterService.marqueesEmitterVar =
      this.eventEmitterService.marqueesEmitter.pipe(takeUntil(this.destroy$)).subscribe(() => {
        if (this.isBrowser) {
          this.marquees$ = JSON.parse(localStorage.getItem('marquees') || '[]');
        }
        this.rebuildMarqueeContents();
        // read maintenance data from local storage
        this.readMaintenanceFromStorageOnly();
        this.computeCombinedMarquee();
      });

    if (this.isBrowser && environment.production) {
      const hotjarSubscription = this.store.pipe(select(IsLoggedIn)).subscribe(res => {
        if (!res) {
          const script = document.createElement('script');
          script.src = '/assets/integrations/hotjar-tracker-home.js';
          document.getElementsByTagName('head')[0].appendChild(script);
        } else {
          document.body.classList.add('logged-in');
        }
      });
      this.unsubscribe.push(hotjarSubscription);
    }

    if (this.isBrowser) {
      const userBrowser = (localStorage.getItem('user_browser'));
      if (userBrowser) {
        const { isDesktop } = JSON.parse(userBrowser);
        const platformClient = isDesktop ? 'live_desk' : 'live_mob';
        this.playtechClient = platformClient;
      }
    }
    this.isLoggedIn$ = this.store.pipe(select(IsLoggedIn));

    // Data loading below reads localStorage (availableProvider) and hits HTTP; must not run during SSR.
    if (!this.isBrowser) return;
    
    // If loggedIn is true, add delay to prevent too early call API without access token
    this.isLoggedIn$.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      setTimeout(() => { this.getAllGameProvider().then(() => { this.showHotGames(); }) }, res ? 500 : 0);
      if (res) {
        // setTimeout(() => {
        //   this.getUserStatus();
        // }, 500)
        this.firstAvailableProviderSL = this.availableProvider?.['SL']?.filter((x:any) => x.maintenance == 0)[0];
      } else {
        this.eventEmitterService.topBarTabVar = this.eventEmitterService.topBarTabEmitter.pipe(takeUntil(this.destroy$)).subscribe(() => {
          if (this.isBrowser) {
            this.availableProvider = JSON.parse(localStorage.getItem('available_providers'));
          }
          if (this.availableProvider !== null) {
            this.firstAvailableProviderSL = this.availableProvider['SL'][0];
          }
        });
      }
    });

    this.systemSettingHttpService.getWithQuery('promotion').subscribe(res => {
      this.systemSettingOption = res.option;
    });

    this.eventEmitterService.availableProviderVar = this.eventEmitterService.availableProviderEmitter.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.getAllGameProvider();
    });

    this.eventEmitterService.selectProviderTabVar = this.eventEmitterService.selectProviderTabEmitter.pipe(takeUntil(this.destroy$)).subscribe(gameCategory => {
      this.categoryGames = this.gameCategoryProviders$[gameCategory.code];
      this.activeGameCategoryCode = gameCategory.code;
      this.activeGameCategoryName = gameCategory.name;
    });

    this.eventEmitterService.updateFavoriteVar = this.eventEmitterService.updateFavoriteEmitter.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.getAllGameProvider(this.activeGameCategoryCode, true);
    });

    this.getFaqs();

    this.getUsp();

    this.eventEmitterService.updateUspVar = this.eventEmitterService.updateUspEmitter.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.getUsp();
    });

    this.resetPromotion();

    of(null).pipe(
      delay(500), tap(() => {
        this.verificationMessage();
        this.refreshDisplay();
      }
      )).subscribe();

    this.eventEmitterService.countryCodeEmitter.pipe(takeUntil(this.destroy$)).subscribe(() => {
      // once login, check country code and currency
      this.refreshDisplay();
    });
  }

  private languagePollInterval: any = null;

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.unsubscribe.forEach(sub => sub.unsubscribe());
    if (this.languagePollInterval) clearInterval(this.languagePollInterval);
    this.destroy$.next();
    this.destroy$.complete();
  }

  onTriggerDialog() {
    if (!this.isBrowser) return;
    if (this.freespinDialog !== null && (localStorage.getItem('user_data') !== null)) {
      let FSType = this.freespinDialog;
      // TODO
      // this.dialog.open(FreeSpinComponent, { width: 'auto', data: { type: FSType } });
      localStorage.removeItem('freespin_dialog');
    }
  }

  onFormatDate() {
    return { day: moment(this.today).format('dddd'), date: moment(this.today).format('Do MMMM YYYY'), full: moment(this.today).format('Do MMMM hh:mm') };
  }

  onFormatDateSoon(date: string) {
    const dateSoon = new Date(date)
    return { full: moment(dateSoon).format('Do MMMM hh:mm') };
  }

  onCloseDetails(category: string) {
    if (category === 'casino') {
      this.casinoActive = false;
      this.casinoActiveGame = '';
    } else if (category === 'slots') {
      this.slotsActive = false;
      this.slotsActiveGame = {
        game_provider_code: '',
        type: ''
      };
    } else if (category === 'sports') {
      this.sportsActive = false;
      this.sportsActiveGame = '';
    } else if (category === 'fishing') {
      this.fishingActive = false;
      this.fishingActiveGame = {
        game_provider_code: '',
        type: ''
      }
    }
  }

  onSelectGame(game: any, category: string, index?: number) {
    if (category === 'casino') {
      this.activeCasinoCategory = game;
      this.casinoActiveGame = game.game_provider_code;
      this.casinoGameDetails = {
        backGround: game.filename.split('.', 2)[0],
        logo: game.filename.split('.', 2)[0],
        name: game.game_provider_name,
        details: game.description,
        maintenance: game.maintenance,
        maintainTime: game.maintain_time_left,
        maintainEnd: game.maintain_end,
        image: game.image
      };
      this.casinoActive = true;
    } else if (category === 'slots') {
      this.activeSlotIndex = index;
      this.activeSlotCategory = game;
      this.slotsActiveGame = {
        game_provider_code: game.game_provider_code,
        type: game.type
      };
      this.slotsGameDetails = {
        backGround: game.filename.split('.', 2)[0],
        logo: game.filename.split('.', 2)[0],
        name: game.game_provider_name,
        details: game.description,
        maintenance: game.maintenance,
        maintainTime: game.maintain_time_left,
        maintainEnd: game.maintain_end,
        image: game.image
      };
      this.slotsActive = true;
    } else if (category === 'sports') {
      this.activeSportCategory = game;
      this.sportsActiveGame = game.game_provider_code;
      this.sportsGameDetails = {
        backGround: game.filename.split('.', 2)[0],
        logo: game.filename.split('.', 2)[0],
        name: game.game_provider_name,
        details: game.description,
        maintenance: game.maintenance,
        maintainTime: game.maintain_time_left,
        maintainEnd: game.maintain_end,
        image: game.image

      };
      this.sportsActive = true;
    } else if (category === 'fishing') {
      this.activeFishingCategory = game;
      this.fishingActiveGame = game.game_provider_code;
      this.fishingGameDetails = {
        backGround: game.filename.split('.', 2)[0],
        logo: game.filename.split('.', 2)[0],
        name: game.game_provider_name,
        details: game.description,
        maintenance: game.maintenance,
        maintainTime: game.maintain_time_left,
        maintainEnd: game.maintain_end,
        image: game.image

      };
      this.fishingActive = true;
    } else if (category === 'esports') {
      this.activeEsportCategory = game;
      this.esportsActiveGame = game.game_provider_code;
      this.esportsGameDetails = {
        backGround: game.filename.split('.', 2)[0],
        logo: game.filename.split('.', 2)[0],
        name: game.game_provider_name,
        details: game.description,
        maintenance: game.maintenance,
        maintainTime: game.maintain_time_left,
        maintainEnd: game.maintain_end,
        image: game.image
      };
      this.esportsActive = true;
    } else if (category === 'poker') {
      this.activePokerCategory = game;
      this.pokerActiveGame = game.game_provider_code;
      this.pokerGameDetails = {
        backGround: game.filename.split('.', 2)[0],
        logo: game.filename.split('.', 2)[0],
        name: game.game_provider_name,
        details: game.description,
        maintenance: game.maintenance,
        maintainTime: game.maintain_time_left,
        maintainEnd: game.maintain_end,
        image: game.image
      };
      this.pokerActive = true;
    }
    if (this.isBrowser && localStorage.getItem('user_data') !== null && game.maintenance == '1') {
      this.showPlayNow = false;
      this.onMaintenance = true;
    } else {
      this.onShowPlayNow();
    }
  }

  onPlayGame(gameCategory: string, gameProvider: any) {
    if (!this.isBrowser) return;
    const dateEnd = Date.parse(gameProvider.maintain_end);
    const dateNow = new Date().getTime();
    if (localStorage.getItem('user_data') === null) {
      // TODO
      // this.dialog.open(LoginModalComponent, { width: '800px' });
    }
    else if (gameProvider.maintenance === 1 && dateEnd > dateNow) {
      this.contentHash = Math.random().toString(36).substring(7);
      // TODO
      // this.dialog.open(CountDownDetailsComponent, {
      //   width: '400px',
      //   data: {
      //     dateEnd: gameProvider.maintain_end,
      //     name: gameProvider.game_provider_name,
      //     time: gameProvider.maintain_time_left,
      //   }
      // });
    }
    //maintenance with no end date
    else if (gameProvider.maintenance === 1 && gameProvider.maintain_end === '') {
      this.contentHash = Math.random().toString(36).substring(7);
      // TODO
      // this.dialog.open(CountDownDetailsComponent, {
      //   width: '400px',
      //   data: {
      //     name: gameProvider.game_provider_name,
      //     time: gameProvider.maintain_time_left,
      //   }
      // });
    } else {
      localStorage.setItem('gameProviderCode', gameProvider.game_provider_code);
      localStorage.setItem('gameCategory', gameCategory);
      localStorage.setItem('isPlayTechClicked', (gameProvider.game_provider_code === "PT").toString());
      localStorage.setItem('gameProviderId', gameProvider.game_provider_id);

      this.router.navigate([]).then(() => { window.open('/gamelaunch', this.gameLaunchWindowTargetService.getTarget(gameProvider.game_provider_code)); });
    }
  }

  onDefaultCasino(event: any) {
    event.target.src = '/assets/images/transparent_coming_soon_image.png';
  }

  onDefaultSlot(event: any) {
    event.target.src = '/assets/images/transparent_coming_soon_image.png';
  }

  onDefaultFishing(event: any) {
    event.target.src = '/assets/images/transparent_coming_soon_image.png';
  }

  onDefaultSports(event: any) {
    event.target.src = '/assets/images/transparent_coming_soon_image.png';
  }

  promotionPage(category: string) {
    this.router.navigate(['/promotion'], { state: { activeCategory: category } });
  }

  onSlotsPage(activeCategory: any, providerCode: string, typeFromHome?: string, indexFromHome?: string) {
    if (!this.isBrowser) return;
    this.dateEnd = Date.parse(activeCategory.maintain_end);
    this.dateNow = new Date().getTime();

    if (localStorage.getItem('user_data') === null && typeFromHome === 'APP') {
      // TODO
      // this.openDialogBy(LoginModalComponent);
    }
    else if (activeCategory.maintenance === 1 && localStorage.getItem('user_data') !== null && this.dateEnd > this.dateNow) {
      this.contentHash = Math.random().toString(36).substring(7);
      // TODO
      // this.dialog.open(CountDownDetailsComponent, {
      //   width: '400px',
      //   data: {
      //     dateEnd: activeCategory.maintain_end,
      //     name: activeCategory.game_provider_name,
      //     time: activeCategory.maintain_time_left,
      //   }
      // });
    } else if (activeCategory.maintenance === 1 && localStorage.getItem('user_data') !== null && activeCategory.maintain_time_left === '') {
      this.contentHash = Math.random().toString(36).substring(7);
      // TODO
      // this.dialog.open(CountDownDetailsComponent, {
      //   width: '400px',
      //   data: {
      //     name: activeCategory.game_provider_name,
      //     time: activeCategory.maintain_time_left,
      //   }
      // });
    } else {
      this.router.navigate(['/slots-game/' + (activeCategory.game_provider_name).replace(/\s/g, '').toLowerCase()], { state: { activeCategory: activeCategory, providerCode: providerCode, typeFromHome: typeFromHome, slotIndexFromHome: indexFromHome, activeGameCategoryTab: 'slots' } });
    }
  }

  onFishingPage(activeCategory: any, providerCode: string, indexFromHome: string) {
    if (!this.isBrowser) return;
    this.dateEnd = Date.parse(activeCategory.maintain_end);
    this.dateNow = new Date().getTime();

    if (activeCategory.maintenance === 1 && localStorage.getItem('user_data') !== null && this.dateEnd > this.dateNow) {
      this.contentHash = Math.random().toString(36).substring(7);
      // TODO
      // this.dialog.open(CountDownDetailsComponent, {
      //   width: '400px',
      //   data: {
      //     dateEnd: activeCategory.maintain_end,
      //     name: activeCategory.game_provider_name,
      //     time: activeCategory.maintain_time_left,
      //   }
      // });
    } else if (activeCategory.maintenance === 1 && localStorage.getItem('user_data') !== null && activeCategory.maintain_time_left === '') {
      this.contentHash = Math.random().toString(36).substring(7);
      // TODO
      // this.dialog.open(CountDownDetailsComponent, {
      //   width: '400px',
      //   data: {
      //     name: activeCategory.game_provider_name,
      //     time: activeCategory.maintain_time_left,
      //   }
      // });
    } else {
      this.router.navigate(['/fishing/' + (activeCategory.game_provider_name).replace(/\s/g, '').toLowerCase()], { state: { activeCategoryFS: activeCategory, providerCodeFS: providerCode, activeGameCategoryTab: 'fishing', fishingindexFromHome: indexFromHome } });
    }
  }

  onCheckBonus(game: any, activeCategory: any) {
    if (!this.isBrowser) return;
    this.systemSettingHttpService.getWithQuery('promotion').subscribe(res => {
      this.systemSettingOption = res.option;
      if (this.systemSettingOption.unclaim_promotion_notification == 1 && localStorage.getItem('bonus') !== null && JSON.parse(localStorage.getItem('bonus')).bonus_notice == true) {
        Swal.fire({
          title: '<div>' + this.svg.rewardAlertIcon + '</div>',
          html: '<div class="text-center font-color-6">' + this.translateService.instant('You have a bonus waiting to be claimed.<br> Would you like to claim it before you play?') + '</div>',
          footer: '<input type="checkbox" id="swal2-checkbox" value="1"> <span class="checkmark"></span>' + this.translateService.instant('Do Not Show Again'),
          showDenyButton: true,
          showCloseButton: true,
          showCancelButton: false,
          showConfirmButton: true,
          reverseButtons: true,
          denyButtonText: this.translateService.instant('SKIP'),
          confirmButtonText: this.translateService.instant('CLAIM NOW'),
          customClass: {
            denyButton: 'deny-button',
            confirmButton: 'confirm-button',
          }
        }).then(result => {

          const checkbox = document.getElementById('swal2-checkbox') as HTMLInputElement;

          if (checkbox?.checked) {
            var bonus = JSON.parse(localStorage.getItem("bonus"));
            bonus.bonus_notice = false;
            localStorage.setItem("bonus", JSON.stringify(bonus));
          }

          if (result.isConfirmed) {
            this.router.navigateByUrl('/promotion');
          } else if (result.isDenied) {
            this.onRedirect(game, activeCategory);
          }
        });
      } else {
        this.onRedirect(game, activeCategory);
      }
    });
  }

  onCheckBonusForHotGame(gameProvider: any, gameCode: string, gameType: string, isDemo = false) {
    if (!this.isBrowser) return;
    // Guest: prompt to log in before launching any hot game.
    if (localStorage.getItem('user_data') === null) {
      this.dialog.open(LoginModalComponent, { panelClass: 'auth-modal-pane', autoFocus: false });
      return;
    }
    this.activeProviderData = this.slotProviders.find(item => item.game_provider_code === gameProvider.game_provider_code);
    if (this.activeProviderData) {
      if (this.systemSettingOption.unclaim_promotion_notification == 1
        && localStorage.getItem('user_data') !== null
        && this.activeProviderData.maintenance === 0
        && this.activeProviderData.available === 1
        && localStorage.getItem('bonus') !== null
        && JSON.parse(localStorage.getItem('bonus')).bonus_notice == true) {
        Swal.fire({
          title: '<div>' + this.svg.rewardAlertIcon + '</div>',
          html: '<div class="text-center font-color-6">' + this.translateService.instant('You have a bonus waiting to be claimed.<br> Would you like to claim it before you play?') + '</div>',
          footer: '<input type="checkbox" id="swal2-checkbox" value="1"> <span class="checkmark"></span>' + this.translateService.instant('Do Not Show Again'),
          showDenyButton: true,
          showCloseButton: true,
          showCancelButton: false,
          showConfirmButton: true,
          reverseButtons: true,
          denyButtonText: this.translateService.instant('SKIP'),
          confirmButtonText: this.translateService.instant('CLAIM NOW'),
          customClass: {
            denyButton: 'deny-button',
            confirmButton: 'confirm-button',
          }
        }).then(result => {

          const checkbox = document.getElementById('swal2-checkbox') as HTMLInputElement;

          if (checkbox?.checked) {
            var bonus = JSON.parse(localStorage.getItem("bonus"));
            bonus.bonus_notice = false;
            localStorage.setItem("bonus", JSON.stringify(bonus));
          }

          if (result.isConfirmed) {
            this.router.navigateByUrl('/promotion');
          } else if (result.isDenied) {
            this.onSelectGameBy(gameProvider, gameCode, gameType, isDemo);
          }
        });
      } else {
        this.onSelectGameBy(gameProvider, gameCode, gameType, isDemo);
      }
    }
  }

  onSelectGameBy(gameProvider: any, gameCode: string, gameType: string, isDemo: boolean) {
    if (!this.isBrowser) return;
    let rowNumber: number;
    this.slotsCategories$.forEach((row, index) => {
      if (row.find((x:any) => x.game_provider_code === gameProvider.game_provider_code)) {
        rowNumber = index;
      }
    })
    // To update the params on the URL
    if (gameProvider !== undefined && Object.keys(gameProvider)) {
      if (gameProvider.game_provider_name !== undefined) {
        // Need to manually trigger seoService since we manually update the url without doing routing
        this.seoService.execute();
      }
    }

    const provider = this.slotProviders.find(item => item.game_provider_code === gameProvider.game_provider_code);
    if (provider) {
      const game_provider_id = provider.game_provider_id;
      localStorage.setItem('gameDemo', '0');
      localStorage.setItem('gameMode', 'real');
      if (localStorage.getItem('user_data') === null) {
        this.dialog.open(LoginModalComponent, { panelClass: 'auth-modal-pane', autoFocus: false });
      }
      else {
        if (gameCode === null) {
          this.onLaunchHotGameBy(gameProvider, gameCode, gameType, isDemo);
        } else {
          localStorage.setItem('gameProviderCode', gameProvider.game_provider_code);
          localStorage.setItem('gameProviderId', game_provider_id);
          localStorage.setItem('gameCode', gameCode);
          localStorage.setItem('gameCategory', 'SL');
          localStorage.setItem('gameType', gameType);
          localStorage.setItem('isPlayTechClicked', (gameProvider.game_provider_code === "PT").toString());
          localStorage.setItem('gameMode', 'real');
          this.onLaunchHotGameBy(gameProvider, gameCode, gameType, isDemo);
        }
      }
    }
  }

  onRedirect(game: any, activeCategory: any) {
    if (activeCategory === 'LC') {
      this.router.navigate([`/casino-game/${game.game_provider_name.replace(/\s/g, '').toLowerCase()}`]);
    }
    else if (activeCategory === 'SL') {
      this.router.navigate([`/slots-game/${game.game_provider_name.replace(/\s/g, '').toLowerCase()}`]);
    }
    else if (activeCategory === 'FS') {
      this.router.navigate([`/fishing/${game.game_provider_name.replace(/\s/g, '').toLowerCase()}`]);
    }
    else if (activeCategory === 'SP') {
      this.router.navigate([`/sports/${game.game_provider_name.replace(/\s/g, '').toLowerCase()}`]);
    }
    else if (activeCategory === 'ES') {
      this.router.navigate([`/esports/${game.game_provider_name.replace(/\s/g, '').toLowerCase()}`]);
    }
    else if (activeCategory === 'PK') {
      this.router.navigate([`/poker/${game.game_provider_name.replace(/\s/g, '').toLowerCase()}`]);
    }
    else if (activeCategory === 'CF') {
      this.router.navigate([`/cock-fighting/${game.game_provider_name.replace(/\s/g, '').toLowerCase()}`]);
    }
    else if (activeCategory === 'CK') {
      this.router.navigate([`/crickets/${game.game_provider_name.replace(/\s/g, '').toLowerCase()}`]);
    }
    else if (activeCategory === 'LT') {
      this.router.navigate([`/lottery/${game.game_provider_name.replace(/\s/g, '').toLowerCase()}`]);
    }
    else if (activeCategory === 'CG') {
      this.router.navigate([`/crash-game/${game.game_provider_name.replace(/\s/g, '').toLowerCase()}`]);
    }
    else if (activeCategory === 'TB') {
      this.router.navigate([`/table/${game.game_provider_name.replace(/\s/g, '').toLowerCase()}`]);
    }
  }

  onCheckGameLater(utc_timestart: string, inProgress: number) {
    let isLater = false;
    let isSooner = false;
    if (inProgress === 0) {
      var startDate = moment(utc_timestart);
      var currentDate = moment();
      if (startDate.date() !== currentDate.date()) {
        isLater = false;
        isSooner = true;
      } else {
        isLater = true;
        isSooner = false;
      }
    }

    return { later: isLater, sooner: isSooner };
  }

  onSplit(data: string) {
    return data.split(' ');
  }

  onFavouriteWidget(favoriteGame: any) {
    if (favoriteGame.category_code === 'FS' || favoriteGame.category_code === 'SL') {
      if (favoriteGame.game_type === 'game_provider') {
        if (favoriteGame.category_code === 'SL') {
          this.onSlotsPage(favoriteGame, favoriteGame.game_provider_code, favoriteGame.type, '0');
        } else {
          this.onFishingPage(favoriteGame, favoriteGame.game_provider_code, '0');
        }
      } else {
        if (favoriteGame.category_code === 'SL') {
          this.onLaunchSlots(favoriteGame);
        } else {
          this.onLaunchFishing(favoriteGame);
        }
      }
    } else {
      this.onPlayGame(favoriteGame.category_code, favoriteGame)
    }

  }

  onLaunchSlots(item: any, isDemo = false) {
    if (!this.isBrowser) return;
    this.dateEnd = Date.parse(item.maintain_end);
    this.dateNow = new Date().getTime();

    if (isDemo == true) {
      localStorage.setItem('gameProviderCode', item.game_provider_code);
      localStorage.setItem('gameProviderId', item.game_provider_id);
      localStorage.setItem('gameCode', item.code);
      localStorage.setItem('gameCategory', 'SL');
      localStorage.setItem('gameType', 'SLOTS');
      localStorage.setItem('isPlayTechClicked', (item.game_provider_code === "PT").toString());

      localStorage.setItem('gameDemo', '1');
      localStorage.setItem('gameMode', 'demo');

      this.onLaunchGameBy(item, item.code, 'SLOTS', isDemo);
    } else {
      localStorage.setItem('gameDemo', '0');
      localStorage.setItem('gameMode', 'real');
      if (localStorage.getItem('user_data') === null) {
        this.dialog.open(LoginModalComponent, { panelClass: 'auth-modal-pane', autoFocus: false });
      }
      // APP type
      else if (item.maintenance === 1 && item.code === null) {
        this.onLaunchGameBy(item, item.code, 'SLOTS', isDemo, item.game_type);

        setTimeout(() => {
          if (this.dateEnd > this.dateNow) {
            this.contentHash = Math.random().toString(36).substring(7);
            // TODO
            // this.dialog.open(CountDownDetailsComponent, {
            //   width: '400px',
            //   data: {
            //     dateEnd: item.maintain_end,
            //     name: item.game_provider_name,
            //     time: item.maintain_time_left,
            //   }
            // });
          } else if (item.maintain_time_left === '') {
            this.contentHash = Math.random().toString(36).substring(7);

            // TODO
            // this.dialog.open(CountDownDetailsComponent, {
            //   width: '400px',
            //   data: {
            //     dateEnd: item.maintain_end,
            //     name: item.game_provider_name,
            //     time: item.maintain_time_left,
            //   }
            // });
          }
        }, 1000);

        // LIST type
      } else if (item.maintenance === 1 && item.code !== null && this.dateEnd > this.dateNow) {
        this.contentHash = Math.random().toString(36).substring(7);
        // TODO
        // this.dialog.open(CountDownDetailsComponent, {
        //   width: '400px',
        //   data: {
        //     dateEnd: item.maintain_end,
        //     name: item.game_provider_name,
        //     time: item.maintain_time_left,
        //   }
        // });
      } else if (item.maintenance === 1 && item.code !== null && item.maintain_time_left === '') {
        this.contentHash = Math.random().toString(36).substring(7);
        // TODO
        // this.dialog.open(CountDownDetailsComponent, {
        //   width: '400px',
        //   data: {
        //     name: item.game_provider_name,
        //     time: item.maintain_time_left,
        //   }
        // });
      } else {
        if (item.code === null) {
          this.onLaunchGameBy(item, item.code, 'SLOTS', isDemo, item.game_type);
        } else {
          localStorage.setItem('gameProviderCode', item.game_provider_code);
          localStorage.setItem('gameProviderId', item.game_provider_id);
          localStorage.setItem('gameCode', item.code);
          localStorage.setItem('gameCategory', 'SL');
          localStorage.setItem('gameType', 'SLOTS');
          localStorage.setItem('isPlayTechClicked', (item.game_provider_code === "PT").toString());
          localStorage.setItem('gameMode', 'real');
          this.onLaunchGameBy(item, item.code, 'SLOTS', isDemo);
        }
      }
    }
  }

  onLaunchFishing(item: any) {
    if (!this.isBrowser) return;
    this.dateEnd = Date.parse(item.maintain_end);
    this.dateNow = new Date().getTime();

    if (localStorage.getItem('user_data') === null) {
      // TODO
      // this.openDialogBy(LoginModalComponent);
    }
    else if (item.maintenance === 1 && this.dateEnd > this.dateNow) {
      this.contentHash = Math.random().toString(36).substring(7);
      // TODO
      // this.dialog.open(CountDownDetailsComponent, {
      //   width: '400px',
      //   data: {
      //     dateEnd: item.maintain_end,
      //     name: item.game_provider_name,
      //     time: item.maintain_time_left,
      //   }
      // });
    } else if (item.maintenance === 1 && item.maintain_time_left === '') {
      this.contentHash = Math.random().toString(36).substring(7);
      // TODO
      // this.dialog.open(CountDownDetailsComponent, {
      //   width: '400px',
      //   data: {
      //     name: item.game_provider_name,
      //     time: item.maintain_time_left,
      //   }
      // });
    } else {
      localStorage.setItem('gameProviderCode', item.game_provider_code);
      localStorage.setItem('gameProviderId', item.game_provider_id);
      localStorage.setItem('gameCategory', 'FS');
      localStorage.setItem('playtechCategory', 'singleGame');
      localStorage.setItem('gameType', 'FISHING');
      localStorage.setItem('gameCode', item.code);
      localStorage.setItem('isPlayTechClicked', (item.game_provider_code === "PT").toString());

      this.router.navigate([]).then(() => { window.open('/gamelaunch', this.gameLaunchWindowTargetService.getTarget(item.game_provider_code)); });
    }
  }

  onLaunchGameBy(item: any, gameCode: string, gameType: string, isDemo = false, slotsType?: string) {
    if (gameCode !== null && slotsType !== 'APP') {
      if (this.isBrowser) {
        this.router.navigate([]).then(() => { window.open('/gamelaunch', this.gameLaunchWindowTargetService.getTarget(item.game_provider_code)); });
      }
    } else {
      this.router.navigate(['/slots-game/' + (item.game_provider_name).replace(/\s/g, '').toLowerCase()], { state: { item: item, slotsType: slotsType } });
    }
  }

  onLaunchHotGameBy(gameProvider: any, gameCode: string, gameType: string, isDemo = false) {
    if ((gameCode !== null || gameProvider.type !== 'APP') && this.isBrowser) {
      this.router.navigate([]).then(() => { window.open('/gamelaunch', this.gameLaunchWindowTargetService.getTarget(gameProvider.game_provider_code)); });
    }
  }

  /* Memoized: called from template bindings (checkImg etc.) on every change-detection
     cycle — parse each distinct string once instead of re-running JSON.parse per CD. */
  private jsonCache = new Map<string, any>();
  toJSON(content: string) {
    if (content == undefined || content == null) {
      return {}
    }
    let parsed = this.jsonCache.get(content);
    if (parsed === undefined) {
      parsed = JSON.parse(content);
      this.jsonCache.set(content, parsed);
    }
    return parsed;
  }

  onDotaPage() {
    if (!this.isBrowser) return;
    this.router.navigate([]).then(() => { window.open('/the-international-10', '_blank'); });
  }

  private setComingSoon(items: any, type: string) {
    if (type === 'fishing' && items.length > 0) {
      this.fishingCategories$ = [];
      this.fishingCategories$.push(items);
      if (this.fishingCategories$[this.fishingCategories$.length - 1].length < 6) {
        const missingIndex = 6 - this.fishingCategories$[this.fishingCategories$.length - 1].length;
        for (let i = 0; i < missingIndex; i++) {
          this.fishingCategories$[this.fishingCategories$.length - 1].push({
            filename: 'transparent_coming_soon.png',
            game_provider_code: 'none',
            game_provider_name: '',
            hide: true
          });
        }
      }
    } else if (type === 'sports' && items.length > 0) {
      this.sportsCategories$ = [];
      this.sportsCategories$.push(items);
      if (this.sportsCategories$[this.sportsCategories$.length - 1].length < 6) {
        const missingIndex = 6 - this.sportsCategories$[this.sportsCategories$.length - 1].length;
        for (let i = 0; i < missingIndex; i++) {
          this.sportsCategories$[this.sportsCategories$.length - 1].push({
            filename: 'transparent_coming_soon.png',
            game_provider_code: 'none',
            game_provider_name: '',
            hide: true
          });
        }
      }
    } else if (type === 'slots' && items.length > 0) {
      this.slotsCategories$ = [];
      this.slotsCategories$.push(...items);
      if (this.slotsCategories$[this.slotsCategories$.length - 1].length < 6) {
        const missingIndex = 6 - this.slotsCategories$[this.slotsCategories$.length - 1].length;
        for (let i = 0; i < missingIndex; i++) {
          this.slotsCategories$[this.slotsCategories$.length - 1].push({
            filename: 'transparent_coming_soon.png',
            game_provider_code: 'none',
            game_provider_name: '',
            hide: true
          });
        }
      }
    } else if (type === 'casino' && items.length > 0) {
      this.liveCasinoCategories$ = [];
      this.liveCasinoCategories$.push(items);
      if (this.liveCasinoCategories$[this.liveCasinoCategories$.length - 1].length < 6) {
        const missingIndex = 6 - this.liveCasinoCategories$[this.liveCasinoCategories$.length - 1].length;
        for (let i = 0; i < missingIndex; i++) {
          this.liveCasinoCategories$[this.liveCasinoCategories$.length - 1].push({
            filename: 'transparent_coming_soon.png',
            game_provider_code: 'none',
            game_provider_name: '',
            hide: true
          });
        }
      }
    }

    else if (type === 'esports' && items.length > 0) {
      this.esportCategories$ = [];
      this.esportCategories$.push(items);
      if (this.esportCategories$[this.esportCategories$.length - 1].length < 6) {
        const missingIndex = 6 - this.esportCategories$[this.esportCategories$.length - 1].length;
        for (let i = 0; i < missingIndex; i++) {
          this.esportCategories$[this.esportCategories$.length - 1].push({
            filename: 'transparent_coming_soon.png',
            game_provider_code: 'none',
            game_provider_name: '',
            hide: true
          });
        }
      }
    }

    if (this.isBrowser) {
      const owlItems = document.getElementsByClassName('crs-hide');
      for (var i = 0; i < owlItems.length; i++) {
        (owlItems[i] as HTMLElement).parentElement.style.opacity = '0';
      }
    }
  }

  onShowPlayNow() {
    this.showPlayNow = true;
    this.onMaintenance = false;
  }

  onGetInstruction(platform: string) {
    // TODO
    // this.dialog.open(AppDownloadModalComponent, {
    //   data: {
    //     platform: platform
    //   }
    // });
  }

  onDownloadApp(platform: string) {
    if (!this.isBrowser) return;
    let link = document.createElement("a");
    link.download = this.siteName;
    switch (platform) {
      case 'android': link.href = "https://b14e9e6a.quickcdn.org/apk/luckyadda_20240812_03.apk"; break;
      case 'ios': link.href = "https://preview.page.link/hangoutparty.page.link?link=https://hkpartygames.com/hangout/app?region%3Dlabdt&apn=com.HKPartyGames.HangoutParty&isi=1660496723&ibi=com.hkpartygames.hangout&ius=hangout28hks"; break;
    }
    link.click();
  }

  private verificationMessage() {
    if (!this.isBrowser) return;
    this.loadingBar.complete();
    const result = JSON.parse(localStorage.getItem('verify_email_message'));
    if (result !== null) {
      const icon = result.success ? '<div class="success-svg">' + this.svg.successIcon + '</div>' : '<div class="alert-svg">' + this.svg.alertIcon + '</div>';
      Swal.fire({
        html: '<img class="msg-icon" src="' + icon + '">' +
          '<div class="text-center mt-3"><ul><li><h3 class="mb-3">'
          + this.translateService.instant('Template 2 Email Verification') +
          '</h3></li><li>'
          + result.message[0] +
          '</li></ul></div>',
        showCloseButton: true,
        confirmButtonText: this.translateService.instant('Okay').toUpperCase(),
      });
      localStorage.removeItem('verify_email_message');
    }
  }

  private async getAllGameProvider(activeTab?: string, isUpdateFavorite?: Boolean) {
    await this.gameCategoryDataService.getAllGameProvider().pipe(
      map((res: any) => {
        this.categories = res;
        this.category_locales = this.gameCategoryDataService.category_locales;
        this.gameCategoryProviders$ = res;
        this.isGameCategoryProivdersFetched = true;
        this.slotProviders = this.gameCategoryProviders$['SL'];
        if (!activeTab) {
          var filter = true;
          Object.keys(this.category_locales).forEach(key => {
            if (this.gameCategoryProviders$[key] && this.gameCategoryProviders$[key].length > 0 && filter) {

              this.activeGameCategoryCode = key;
              this.activeGameCategoryName = this.category_locales[key]['name'].toLowerCase();
              filter = false;

            }
          });
        }

        activeTab = activeTab ? activeTab : this.activeGameCategoryCode;
        this.gameCategoryProviders$ = res;

        if (!isUpdateFavorite) {
          this.categoryGames = this.gameCategoryProviders$[activeTab ? activeTab : this.activeGameCategoryCode];
        }

        this.isSkeletonCategoryLocales = false;
      })
    ).toPromise();
  }

  private openDialogBy(componentRef: any) {
    this.dialog.open(componentRef);
  }

  private getUsp() {
    this.uspSectionHttpService.getAll().subscribe(res => {
      if (res) {
        this.usps = res.contents.rows;
        this.uspMainContent = res.main_descriptions[0] ? res.main_descriptions[0] : null;
        this.uspNumberContents = res.numbers
      }

      this.isSkeletonUsp = false;
    });
  }


  private getFaqs() {
    this.isLoggedIn$.subscribe((res) => {
      setTimeout(() => {
        this.contentDataService.getFAQ().subscribe((res: any) => {
          this.faqs = res['faq_contents']['rows'];
          this.faqsLength = this.faqs.length;
          if (this.faqsLength > 0) { this.faqdata = this.faqs[0].contents.length; }
          this.isSkeletonFaqs = false;
        });
      }, res ? 500 : 0);
    });
  }

  removeSpace(str: any) {
    return str.replace(' ', '')
  }

  sanitize(content: string) {
    return this.sanitizer.bypassSecurityTrustHtml(content);
  }

  private resetPromotion() {
    this.isLoggedIn$.subscribe((res) => {
      setTimeout(() => {
        this.promotionContentDataService.getWithQuery(`?page=${this.page}&perPage=${this.pageSize}${this.params}&paginate=0`).subscribe(promo => {
          this.promotions = promo;
          this.isSkeletonPromotions = false;
        });
      }, res ? 500 : 0);
    });
  }

  checkImg(item: any, imageType: any, maintenance: any) {
    var localImg1 = '/assets/images/vendor/fallback/live-casino/' + item.game_provider_code + '.png';
    var localImg2 = '/assets/images/vendor/fallback/' + item.game_provider_code + '.png';
    /* Parse once; `??` keeps the original null/undefined -> fallback semantics. */
    const img = this.toJSON(item.image);
    var image1 = img.image1 ?? localImg1;
    var image2 = img.image2 ?? localImg2;
    var disable_image1 = img.disable_image1 ?? image1;
    var disable_image2 = img.disable_image2 ?? image2;

    if (maintenance) {
      if (imageType == 1) {
        return disable_image1;
      } else {
        return disable_image2;
      }
    } else {
      if (imageType == 1) {
        return image1;
      } else {
        return image2;
      }
    }
  }

  scroll(id: any) {
    if (!this.isBrowser) return;
    let el = document.getElementById(id);
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  private refreshDisplay() {
    if (this.isBrowser) {
      this.countryCode = localStorage.getItem('country_code');
    }
    if (this.countryCode == 'SG') {
      this.currency = 'SGD';
    }
    else if (this.countryCode == 'TH') {
      this.currency = 'THB';
    }
    else if (this.countryCode == 'ID') {
      this.currency = 'IDR';
    }
    else if (this.countryCode == 'IN') {
      this.currency = 'INR';
    }
    else if (this.countryCode == 'US') {
      this.currency = 'USD';
    }
    else if (this.countryCode == 'BD') {
      this.currency = 'BDT';
    }
    else if (this.countryCode == 'RP') {
      this.currency = 'RP';
    }
    else {
      this.currency = 'MYR';
    }

    const countryConfig = (this.dropdownHttpService.availableCountryAndLanguages[environment.domainName] as any)[this.countryCode];

    this.countryName = countryConfig.name;
  }

  private async showHotGames() {
    if (Object.keys(this.hotGameSession).length === 0) {
      let hotGameProviders = [];
      for (const provider of this.slotProviders) {
        // Skip the provider if it is app type
        if (provider.type.toUpperCase() == 'APP') {
          continue;
        }

        hotGameProviders.push(provider);
      }

      if (this.isSkeletonHotGames) {
        await this.fetchGamesForProvider(hotGameProviders);
      }
    }

    for (const key in this.hotGameSession) {
      const section = this.hotGameSession[key];

      if (Array.isArray(section)) {
        this.gameStack.push(...section);
      } else if (typeof section === 'object') {
        for (const subKey in section) {
          const arr = section[subKey];
          if (Array.isArray(arr)) {
            this.gameStack.push(...arr);
          }
        }
      }
    }

    this.isSkeletonHotGames = false;
  }

  private async fetchGamesForProvider(slotProviders: any): Promise<void> {
    try {
      // Initialize hotGameSession array
      this.hotGameSession = {};

      // Get game list and game images from API
      const gameList: any = await this.gameListDataService.getHotGamesBy(slotProviders, 'SL').toPromise();
      const gameImages = await this.gameListDataService.getGameImages('all', 'SL').toPromise();

      // Ensure game list are fetched successfully
      if (!gameList) {
        return;
      }

      // Append game image data into the game list
      if (gameImages.length) {
        Object.keys(gameList).forEach((key: any) => {
          const localImagePath = gameImages.filter((x) => x['code'] === gameList[key]['code']);
          gameList[key]['local_image_path'] = localImagePath.length ? localImagePath[0]['image_path'] : null;
        });
      }

      gameList.forEach((game: any) => {
        const provider = game.game_provider_code;

        // find matching provider object
        const matchedProvider = slotProviders.find(
          (p: any) => p.game_provider_code === provider
        );

        if (!this.hotGameSession[provider]) {
          this.hotGameSession[provider] = {};
        }

        // For each tag (like All, Hot, Video Slots), put game into corresponding group
        (game.tags || []).forEach((tag: string) => {
          const tagUpper = tag.toUpperCase(); // make "Hot" → "HOT" like your example
          if (tagUpper == 'HOT') {
            if (!this.hotGameSession[provider][tagUpper]) {
              this.hotGameSession[provider][tagUpper] = [];
            }

            // Add extra fields before storing
            const gameWithFlags = {
              ...game,
              showMaintenance: false,
              showNoPromo: false,
              available: matchedProvider ? matchedProvider.available : false,
              maintenance: matchedProvider ? matchedProvider.maintenance : false,
            };
            this.hotGameSession[provider][tagUpper].push(gameWithFlags);

            this.hotGameCount++;
          }
        });
      });

      if (this.isBrowser) {
        sessionStorage.setItem('hotGameSession', JSON.stringify(this.hotGameSession));
      }
    } catch (error) {
      // console.error("Error fetching games for provider:", provider.game_provider_code, error);
    }
  }

  onCheckHover(game: any) {
    this.activeProviderData = this.slotProviders.find(item => item.game_provider_code === game.game_provider_code);
    if (this.activeProviderData.maintenance === 1) {
      game.showMaintenance = true;
      setTimeout(() => {
        game.showMaintenance = false;
      }, 2000);
    }
    else if (this.activeProviderData.available === 0) {
      game.showNoPromo = true;
      setTimeout(() => {
        game.showNoPromo = false;
      }, 2000);
    }
  }

  onImgSrcError(event: any) {
    event.target.src = this.path.replace('#', Math.floor(Math.random() * 6) + '');
  }

  onReadMoreMarquee() {
    if (!this.isBrowser) return;
    let marquee: any[] = [];
    let maintenance: { rows: any[]; empty_message?: string } = { rows: [], empty_message: '' };

    try {
      marquee = JSON.parse(localStorage.getItem('marquees') || '[]');
    } catch { }

    try {
      maintenance = JSON.parse(localStorage.getItem('game_provider_maintenance') || '{"rows":[]}');
    } catch { }

    this.dialog.open(ReadMoreMarqueeModalComponent, {
      autoFocus: false,
      panelClass: 'read-more-modal',
      data: { marquee, maintenance }
    });
  }

  private readAnnouncementsFromStorage(): void {
    if (!this.isBrowser) return;
    try {
      this.marquees$ = JSON.parse(
        localStorage.getItem('marquees') || '[]'
      );
    } catch { this.marquees$ = []; }

    this.readMaintenanceFromStorageOnly();

    this.rebuildMarqueeContents();
  }

  private readMaintenanceFromStorageOnly(): void {
    if (!this.isBrowser) return;
    try {
      const maint = JSON.parse(localStorage.getItem('game_provider_maintenance') || '{"rows":[]}');
      this.maintenanceRows = Array.isArray(maint?.rows) ? maint.rows : [];
    } catch { this.maintenanceRows = []; }
  }

  private rebuildMarqueeContents(): void {
    this.marqueeContents = [];
    if (Array.isArray(this.marquees$)) {
      for (const item of this.marquees$) {
        const contents = Array.isArray(item?.contents) ? item.contents : [];
        for (const c of contents) {
          const text = (c?.content ?? '').toString().trim();
          if (text) this.marqueeContents.push(text);
        }
      }
    }
  }

  private computeCombinedMarquee(): void {
    const marqueeExist = this.marqueeContents.length > 0;
    const maintenanceExist = (this.maintenanceRows?.length || 0) > 0;
    let MAINT_NOTICE = this.translateService.instant('Please note that some games will be under maintenance soon.');
    let NO_UPCOMING = this.translateService.instant('All games are working normally again.');

    if (marqueeExist && maintenanceExist) {
      // 1) Show all marquee text, then add maintenance notice at the end
      this.combinedMarquee = [...this.marqueeContents, MAINT_NOTICE];
    } else if (marqueeExist && !maintenanceExist) {
      // 2) only marquee
      this.combinedMarquee = [...this.marqueeContents];
    } else if (!marqueeExist && maintenanceExist) {
      // 3) only maintenance notice
      this.combinedMarquee = [MAINT_NOTICE];
    } else {
      // 4) default messages
      this.combinedMarquee = [NO_UPCOMING];
    }
  }
}
